export const userNameTakenTitle = 'Change your username';
export const userNameTakenContent =
  'The username you are trying to use is already taken. Please, use a different username.';
export const userNameCreationFailedContent =
  'The user name creation failed. Please try again.';
export const tempPasswordCreationFailedContent =
  'The user name was created but the password creation failed. Please click publish to web and adjust the credentials separately.';

export const getModalInstructions = loadedData => {
  const {
    usernameTaken,
    usernameCreationFailed,
    tempPasswordCreationFailed
  } = loadedData;
  if (usernameTaken) {
    return userNameTakenContent;
  }
  if (usernameCreationFailed) {
    return userNameCreationFailedContent;
  }
  if (tempPasswordCreationFailed) {
    return tempPasswordCreationFailedContent;
  }
  return '';
};
